import type { ReactNode } from 'react';
import type { IntlShape } from 'react-intl';
import DifficultyEasy from '@alltrails/denali/icons/DifficultyEasy';
import DifficultyHard from '@alltrails/denali/icons/DifficultyHard';
import DifficultyModerate from '@alltrails/denali/icons/DifficultyModerate';
import DifficultyStrenuous from '@alltrails/denali/icons/DifficultyStrenuous';
import { getTrailDifficultyDescription, getTrailDifficultyLabel } from './trailDifficultyHelpers';

export type DifficultyLevel = {
  title: ReactNode;
  description: ReactNode;
};

type GetDifficultyLevelsOptions = {
  iconSize?: 'xs' | 'sm' | 'md' | 'lg';
  renderTitle?: (icon: ReactNode, label: ReactNode) => ReactNode;
};

export const getDifficultyLevels = (intl: IntlShape, options?: GetDifficultyLevelsOptions): DifficultyLevel[] => {
  const iconSize = options?.iconSize ?? 'xs';
  const renderTitle =
    options?.renderTitle ??
    ((icon, label) => (
      <>
        {/* snowflake icon is slightly higher than the text */}
        <div style={{ marginTop: '7px' }}>{icon}</div>
        {label}
      </>
    ));

  return [
    {
      title: renderTitle(<DifficultyEasy size={iconSize} color="--color-difficulty-easy" />, getTrailDifficultyLabel(intl, 'easy')),
      description: getTrailDifficultyDescription(intl, 'easy')
    },
    {
      title: renderTitle(<DifficultyModerate size={iconSize} color="--color-difficulty-moderate" />, getTrailDifficultyLabel(intl, 'moderate')),
      description: getTrailDifficultyDescription(intl, 'moderate')
    },
    {
      title: renderTitle(<DifficultyHard size={iconSize} color="--color-difficulty-hard" />, getTrailDifficultyLabel(intl, 'hard')),
      description: getTrailDifficultyDescription(intl, 'hard')
    },
    {
      title: renderTitle(<DifficultyStrenuous size={iconSize} color="--color-difficulty-strenuous" />, getTrailDifficultyLabel(intl, 'strenuous')),
      description: getTrailDifficultyDescription(intl, 'strenuous')
    }
  ];
};
